import React from "react";

import HighlightBlock from "./HighlightBlock";

export default function ProjectVideo({ src, title, highlightBlockProps = {} }) {
    if (!src) return null;

    return (
        <section className="project-video-section">
            <div className="container py-4 text-center">
                <HighlightBlock {...highlightBlockProps}>
                    <div
                        className="project-video-wrapper"
                        style={{
                            margin: "0 auto",
                            borderRadius: 0.4,
                            overflow: "hidden",
                            boxShadow: "0 6px 36px rgba(24,60,40,.14)"
                        }}
                    >
                        <iframe
                            src={src}
                            title={title}
                            width="100%"
                            frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{ minHeight: 220, width: "100%", border: 0, aspectRatio: "16/9" }}
                        />
                    </div>
                </HighlightBlock>
            </div>
        </section>
    );
}
